export const testMode = () =>
  process.env["NEXT_PUBLIC_TEST_WITHOUT_AUTH"] === "1" ? true : false;

// The following are only relevant when clerkEnabled is false, i.e. used for testing
export const isSignedIn = () => true;
export const getUser = () =>
  isSignedIn() ? { id: "testUser_1", email: "levente@bagi.name" } : null;

export const isAdminEmail = (email: string): boolean => {
  const adminEmail = process.env["ADMIN_EMAIL"];
  if (!adminEmail || adminEmail.length === 0) {
    return false;
  }
  return email === adminEmail;
};
